import { render, staticRenderFns } from "./BtnCancelarSolic.vue?vue&type=template&id=2e8bb0c8&"
import script from "./BtnCancelarSolic.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarSolic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports